import Vue from 'vue'
import VueRouter from 'vue-router'
import { i18n } from '../main'
import { session } from '@/js/session';
import { store } from '@/main.js';

Vue.use(VueRouter)

const routes = [
    {
        path: '/secretars',
        name: 'Secretars',
        component: function () {
            return import('@/components/CrudComponents/Secretars.vue')
        },
        meta: {
            requiresAuth: true,
            secretar : true
        }
    },
    {
        path: '/universityYears',
        name: 'UniversityYears',
        component: function () {
            return import('../components/ManageUniversityYears.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/faculties',
        name: 'Faculties',
        component: function () {
            return import('../components/ManageFaculties.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/examinare',
        name: 'Examinare',
        component: function () {
            return import('../components/Examinare.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/sali',
        name: 'Manage Sali',
        component: function () {
            return import('../components/Sali.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/students',
        name: 'Manage Students',
        component: function () {
            return import('../components/ManageStudents.vue')
        },
        meta: {
            requiresAuth: true,
            secretar : true,
        }
    },
    {
        path: '/configuration',
        name: 'Configuration',
        component: function () {
            return import('../components/Configuration.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/customExams',
        name: 'Custom Exams',
        component: function () {
            return import('../components/CustomExams.vue')
        },
        meta: {
            requiresAuth: true,
            secretar : true,
        }
    },
    {
        path: '/teacherExams',
        name: 'Teacher Exams',
        component: function () {
            return import('../components/TeacherExams.vue')
        },
        meta: {
            requiresAuth: true,
            adminTeacher: true
        }
    },
    {
        path: '/appointments',
        name: 'Appointments',
        component: function () {
            return import('../components/ManageAppointments.vue')
        },
        meta: {
            requiresAuth: true,
            secretar: true,
        }
    },
    {
        path: '/',
        name: 'Home',
        component: function () {
            return import('../components/Dashboard.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: function () {
            return import('../components/Login.vue')
        }
    },

    {
        path: '/dashboard',
        name: 'Dashboard',
        component: function () {
            return import('../components/Dashboard.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/exam/:groupId',
        name: 'Exam',
        component: function () {
            return import('../components/Exam.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/test',
        name: 'Test',
        component: function () {
            return import('../components/test.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/question/:skip/:take/:pkCollege/:pkSection/:pkDiscipline/:year',
        name: 'Question',
        component: function () {
            return import('../components/Question.vue')
        },
        meta: {
            requiresAuth: true,
            adminTeacher: true,
        }
    },
    {
        path: '/new-question',
        name: 'NewQuestion',
        props: true,
        component: function () {
            return import('../components/NewQuestion.vue')
        },
        meta: {
            requiresAuth: true,
            adminTeacher: true,
        }
    },
    {
        path: '/:questionId/edit',
        name: 'QuestionEdit',
        params: true,
        params: {
            description: ':description',
        },
        component: function () {
            return import('../components/NewQuestion.vue')
        },
        meta: {
            requiresAuth: true,
            adminTeacher: true,
        }
    },
    {
        path: '/exam-schedule',
        name: 'ExamSchedule',
        component: function () {
            return import('../components/ExamSchedule.vue')
        },
        meta: {
            requiresAuth: true,
            adminTeacher: true,
            secretar: true,
        }
    },
    {
        path: '/prepareExam',
        name: 'PrepareExam',
        component: function () {
            if (process.env.VUE_APP_ROOT_examen == "TRUE")
                return import('../components/PrepareRealExam.vue')
            else
                return import('../components/PrepareExam.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/imports',
        name: 'Imports',
        component: function () {
            return import('../components/Imports.vue')
        },
        meta: {
            requiresAuth: true,
            adminAuth: true,
        }
    },
    {
        path: '/examResult',
        name: 'ExamResult',
        component: function () {
            return import('../components/ExamResult.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/questionPreview',
        name: 'QuestionPreview',
        component: function () {
            if (process.env.VUE_APP_ROOT_examen == "TRUE")
                return import('../components/Dashboard.vue')
            else
                return import('../components/QuestionPreview.vue')

        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/examSimulation',
        name: 'ExamsSimulation',
        component: function () {
            if (process.env.VUE_APP_ROOT_examen == "TRUE")
                return import('../components/Dashboard.vue')
            else
                return import('../components/ExamsSimulation.vue')

        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/examAppointments',
        name: 'ExamAppointments',
        component: function () {
            if (process.env.VUE_APP_ROOT_examen == "TRUE")
                return import('../components/Dashboard.vue')
            else
                return import('../components/ExamAppointments.vue')

        },
        meta: {
            requiresAuth: true,
            secretar: true,
        }
    },
    {
        path: '/disciplineList',
        name: 'DisciplineList',
        component: function () {
            return import('../components/DisciplinesList.vue')
        },
        meta: {
            requiresAuth: true,
            secretar: true,
        }
    },
    {
        path: '/disciplineManage',
        name: 'DisciplineManage',
        component: function () {
            return import('../components/DisciplinesManage.vue')
        },
        meta: {
            requiresAuth: true,
            secretar: true,
        }
    },
    {
        path: '/examsPreview',
        name: 'ExamPreview',
        component: function () {
            return import('../components/ExamsPreview.vue')
        },
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/admin',
        name: 'Admin',
        component: function () {
            return import('../components/Admin.vue')
        },
        meta: {
            requiresAuth: true,
            adminAuth: true
        },

    },
    {
        path: '/adminExamPrint',
        name: 'AdminExamPrint',
        component: function () {
            return import('../components/AdminExamPrint.vue')
        },
        meta: {
            requiresAuth: true,
            adminAuth: true
        },

    },
    {
        path: '/templateExamView/:groupId/:sessionId',
        name: 'templateExamView',
        component: function () {
            return import('../components/TemplateExamView.vue')
        },
        meta: {
            requiresAuth: true,
            adminAuth: true
        },

    },
    {
        path: '/templateExamEdit/:groupId/:sessionId',
        name: 'templateExamEdit',
        component: function () {
            return import('../components/TemplateExamEdit.vue')
        },
        meta: {
            requiresAuth: true,
            adminAuth: true
        },

    },
    {
        path: '/templateExamContest/:groupId/:sessionId',
        name: 'templateExamContest',
        component: function () {
            return import('../components/TemplateExamContest.vue')
        },
        meta: {
            requiresAuth: true,
            adminAuth: true
        },

    },
    {
        path: '/contestations',
        name: 'ExamsContest',
        component: function () {
            return import('../components/ExamsContest.vue')
        },
        meta: {
            requiresAuth: true
        }

    },
    {
        path: '/:postId/resolve',
        name: 'ExamContestEdit',
        params: true,
        params: {
            description: ':description',
        },
        component: function () {
            return import('../components/ExamContestEdit.vue')
        },
        meta: {
            requiresAuth: true,
            adminTeacher: true,
        }
    },
    {
        path: '/studentsExams',
        name: 'StudentsExams',
        component: function () {
            return import('../components/StudentsExams.vue')
        },
        meta: {
            requiresAuth: true,
            adminTeacher: true,
            secretar: true,
        }
    },
    {
        path: '/recording/:fileName', // File name as path variable
        name: 'RrwebPlayer',
        component: function () {
            return import('../components/RrwebPlayer.vue')
        },
        props: true, // This allows the route params to be passed as props to the component
        meta: {
            requiresAuth: true,
            adminTeacher: true,
            secretar: true,
        }
      },
    //{
    //    path: '*',
    //    name: 'PageNotFound',

    //    component: function () {
    //        return import('../components/pageNotFound.vue')
    //    }
    //},


]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    /*render: h => h(App)*/
})

//const router = createRouter({
//    history: createWebHistory(process.env.BASE_URL),
//    routes,
//})

router.beforeEach((to, from, next) => {
    document.title = to.name;

    i18n.locale = localStorage.getItem('language') || 'ro';
    store.commit('SET_PARAMS', to.params)

    if (window.location.search == process.env.VUE_APP_ROOT_inspect) {
        sessionStorage.setItem('VUE_inspect', process.env.VUE_APP_ROOT_inspect);
    }

    if (localStorage.getItem('authenticated') == 'false' && to.name != 'Login') {
        next('login');
    } else if (localStorage.getItem('authenticated') == 'true' && to.name != 'Login') {
        next();
    } else if (to.meta.adminAuth && !session.isAdmin()) {
        next('PageNotFound');
    } else if (to.meta.adminTeacher && !session.isTeacher()) {
        next('PageNotFound');
    } else if (to.meta.secretar && !session.isSecretar()) {
        next('PageNotFound');
    } else {
        next();
    }
})




export default router
